import * as s from './styles';

import type { IGatsbyImageData } from 'gatsby-plugin-image';
import type { IProductsCardFullWidth } from './types';

const ProductsCardFullWidth = ({ buttonText, buttonUrl, desktopImage, mobileImage, text }: IProductsCardFullWidth) => (
    <s.StyledProductsCard
      forwardedAs="a"
      tabIndex={0}
      aria-label={`text: ${text}, image: ${desktopImage.altText}`}
      href={buttonUrl}
    >
      <s.CardContentsContainer>
        <s.StyledButton>
          {buttonText}
        </s.StyledButton>
        <s.SubHeadline>
            {text}
        </s.SubHeadline>
      </s.CardContentsContainer>
      <s.ImageContainer>
        <s.CardDesktopImage imageData={desktopImage.gatsbyImage as IGatsbyImageData} altText={desktopImage?.altText} />
        <s.CardMobileImage imageData={mobileImage.gatsbyImage as IGatsbyImageData} altText={mobileImage?.altText}/>
      </s.ImageContainer>
    </s.StyledProductsCard>
);


export default ProductsCardFullWidth;
